import { Loader2 } from 'lucide-react';

/**
 * Shown for the few hundred milliseconds it takes to read the session out of
 * IndexedDB. Matches the manifest's background colour so an installed PWA has no
 * visible seam between the OS splash and the app.
 */
export function BootSplash({ message = 'Starting…' }: { message?: string }) {
  return (
    <div className="grid h-full place-items-center bg-background">
      <div className="flex flex-col items-center gap-3">
        <img src="/icon.svg" alt="" className="size-12 rounded-xl" />
        <div className="flex items-center gap-2 text-sm text-muted-foreground">
          <Loader2 className="size-4 animate-spin" aria-hidden />
          {message}
        </div>
      </div>
    </div>
  );
}
